// const baseUrl = process.env.NODE_ENV === 'development' ? 'http://localhost:8000/api' : 'https://ambrosia.api.pyaesonenyein.com/';
// const baseUrl = `https://ambrosia.api.pyaesonenyein.com`;
// const baseUrl = 'http://localhost:8080/api/';

// const baseUrl = 'https://www.ambrosia.api.pyaesonenyein.com/api';
// const imageUrl = 'https://www.ambrosia.api.pyaesonenyein.com/';

// const baseUrl = 'http://localhost:8000/api';
// const imageUrl = 'http://localhost:8000';

const baseUrl = 'https://ambrosia.pyaesonenyein.com/api';
const imageUrl = 'https://ambrosia.pyaesonenyein.com';



export { baseUrl, imageUrl };
